import React, { FunctionComponent } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { Box, Text, TextButton } from '@wix/design-system';
import { useRouter } from 'next/router';
import ArrowLeftIcon from 'wix-ui-icons-common/ArrowLeft';
import ArrowRightIcon from 'wix-ui-icons-common/ArrowRight';
import { pageClick } from '@wix/bi-logger-customer-care-data/v2';
import { DATA_HOOKS } from '../../../dataHooks';
import { BI } from '../../../constants';
import { useBI } from '../../../hooks/useBI';
import { isRTL } from '../../../utils/internationalization';
import { RenderHTML } from '../../RenderHTML';
import css from './index.module.scss';

type SearchResultsSubHeaderProps = {
  numberOfResults: number;
  term: string;
};

/**
 * @deprecated use `components/SearchResults/SearchResultsSubHeader/index.tsx` instead
 */

export const DeprecatedSearchResultsHeader: FunctionComponent<
  SearchResultsSubHeaderProps
> = ({ numberOfResults, term }: SearchResultsSubHeaderProps) => {
  const { sendBIEvent } = useBI();
  const { t } = useTranslation();
  const { locale } = useRouter();
  const isRTLLanguage = isRTL(locale);

  const onBackToHomepageClick = async () => {
    await sendBIEvent(
      pageClick({
        source_name: BI.SOURCE_NAMES.SEARCH_RESULTS,
        kb_lang: locale as string,
        clicked_item_type: BI.CLICKED_ITEM_TYPES.HOME_PAGE,
        clicked_text: t('search.results.header.help.center'),
        clicked_url: `${location.origin}/${locale}`,
      })
    );
  };

  return (
    <Box className={css.wrapper} verticalAlign="middle">
      <Box className={css.homepageLink}>
        <TextButton
          as="a"
          href={`/${locale}`}
          size="small"
          prefixIcon={isRTLLanguage ? <ArrowRightIcon /> : <ArrowLeftIcon />}
          dataHook={DATA_HOOKS.SEARCH_RESULTS_HEADER_HOMEPAGE_LINK}
          onClick={onBackToHomepageClick}
          type="link"
        >
          {t('search.results.header.help.center')}
        </TextButton>
      </Box>
      <Text size="small" className={css.queryInfoTextWrapper}>
        <RenderHTML
          html={t('search.results.header.query.info', {
            numberOfResults,
            term,
          })}
          className={css.queryInfo}
          dataHook={DATA_HOOKS.SEARCH_RESULTS_HEADER_QUERY_INFO}
        />
      </Text>
    </Box>
  );
};
